jQuery(document).ready(function($){


    
    
    if (localStorage.getItem('currentPage') !=  window.location.href){
         $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                localStorage.setItem('currentPage', window.location.href);
            },
            error: function(xhr, status, error) {
                console.error('Error clearing cart:', error);
            }
        });
    }

    


    // $('body').addClass('body-account-retailer-drawer');
    

    $('.fon-cart-drawer h2').html('Your Wholesale Order');

    $(document).on('click','#account-retailer-drawer [data-action]',function(){
        var action = $(this).attr('data-action');
        
        if (action == 'order'){
        
        }else{
            $(`.account-content`).removeClass('active');
            $(`.account-content[data-content="${action}"]`).addClass('active');
        }
        
    });


    $(document).on('click','#account-retailer-drawer [data-action="order"] .order-summary-container',function(){
        
        var action = $(this).parents('.order-card').attr('data-action');

        $(`.account-content`).removeClass('active');
        $(`.account-content[data-content="${action}"]`).addClass('active');

        // $('.account-selected-order').append($(this).html());
        $('.account-selected-order').html('');

        // Then append detailed info (from data attributes)
        const $order = $(this).parents('.order-card');

        const orderDetailsHTML = `
            <div class="order-details-full">
            <div class="order-header">
                <h2>Order ${$order.data('order-number')}</h2>
                <p>Placed on ${$order.data('order-date')}</p>
            </div>

            <div class="order-products">
                ${$order.find('.product-image').map(function() {
                const src = $(this).find('img').attr('src');
                const alt = $(this).find('img').attr('alt');
                const payment = $(this).attr('data-payment');
                const quantity = $(this).attr('data-quantity');
                return `
                    <div class="order-item">
                    <img src="${src}" alt="${alt}">
                    <div class="item-info">
                        <p class="item-title">${alt}</p>
                        <p>Quantity: ${quantity}</p>
                        <p>${payment}</p>
                    </div>
                    </div>
                `;
                }).get().join('')}
            </div>


            <div class="order-delivery">
                <a href="${$order.data('order-tracking-url')}" class="btn-track" target="_blank">See Tracking Details</a>
                <a href="#" class="btn-track-see-tracking"
                    data-order-number="${$order.data('order-number')}"
                    data-customer-name="${$order.data('order-shipping-name')}"
                    data-custumer-email="${$order.data('order-email')}"
                >Request Tax Invoice</a>
            </div>

            <div class="order-summary">
                <table>
                <tr>
                    <td>Subtotal</td>
                    <td>$${$order.data('order-subtotal')}</td>
                </tr>
                <tr>
                    <td>Shipping</td>
                    <td>$${$order.data('order-shipping')}</td>
                </tr>
                <tr class="total"> 
                    <td><strong>Total</strong></td>
                    <td><strong>$${$order.data('order-total')}</strong></td>
                </tr>
                </table>
            </div>

            <div class="order-addresses">
                <div class="order-address shipping">
                <h4>Shipping Address</h4>
                <p>${$order.data('order-shipping-name')}</p>
                <p>${$order.data('order-shipping-address1')}</p>
                ${$order.data('order-shipping-address2') ? `<p>${$order.data('order-shipping-address2')}</p>` : ''}
                <p>${$order.data('order-shipping-city')}, ${$order.data('order-shipping-province')} ${$order.data('order-shipping-zip')}</p>
                <p>${$order.data('order-shipping-country')}</p>
                </div>

                <div class="order-address billing">
                <h4>Billing Address</h4>
                <p>${$order.data('order-billing-name')}</p>
                <p>${$order.data('order-billing-address1')}</p>
                ${$order.data('order-billing-address2') ? `<p>${$order.data('order-billing-address2')}</p>` : ''}
                <p>${$order.data('order-billing-city')}, ${$order.data('order-billing-province')} ${$order.data('order-billing-zip')}</p>
                <p>${$order.data('order-billing-country')}</p>
                </div>

            </div>
            </div>
        `;

        $('.account-selected-order').append(orderDetailsHTML);

    });



    $(document).on('click','.account-container.open-account-retailers',function(){
        $('body').addClass('body-account-retailer-drawer');
    });

    $(document).on('click','#account-retailer-drawer div.account-header .back',function(){
        if ($('.account-content.active').attr('data-content') == 'start'){
            $('body').removeClass('body-account-retailer-drawer');
        }else{
            var action = $(`.account-content.active`).attr('data-back');
            $(`.account-content`).removeClass('active');
            $(`.account-content[data-content="${action}"]`).addClass('active');
        }
    });

    
    const cartDiscountCode = $('#retailer-portal-wrapper').attr('data-tier-discount-discount'); // optional

    // Open Margin Calculator
    $(document).on('click','.portal-margin-caculator button, .welcome-kit-subtotal .second',function(){

        var step = 1;
        $(`.margin-container`).removeClass('active');
        $(`.margin-${step}-container`).addClass('active');
        
        $.magnificPopup.open({
            items: {
                src: '#mfp-margin-calculator',
                type: 'inline'
            },
            modal: false,
            closeBtnInside: true,
            closeMarkup: `
            <button title="%title%" type="button" class="mfp-close">
                <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                </svg>
            </button>
            `,
            closeOnBgClick: false,   // ❌ disables background close
        });
    });


   

 

    // Step 1 Margin Calculator
    $(document).on('click','.margin-1-container .options > div',function(){

        var action = $(this).attr('data-action');
        var parent = $(this).parents('.margin-1-container');

        $('.margin-1-container .options > div').removeClass('active');
        $(this).addClass('active');

        parent.find('.btn-continue').prop('disabled',false);

    });

    $(document).on('click','.margin-container p.back',function(){

        var parent = $(this).parents('.margin-container');
        var step = parseInt(parent.attr('data-step'));
        var nextStep = step - 1;

        $(`.margin-${step}-container`).removeClass('active');
        $(`.margin-${nextStep}-container`).addClass('active');

    

    });


    $(document).on('click','.margin-container .btn-continue',function(){


        var totalCost = 0;
        var totalProfit = 0;
        var totalMonthlyNetRev = 0;

        var parent = $(this).parents('.margin-container');
        var step = parseInt(parent.attr('data-step'));
        var nextStep = step + 1;
        var selected = $('.margin-1-container .options > div.active');

        // Calc
        if (nextStep == 2){

            if ($("#price-slider").hasClass("ui-slider")) {
                $("#price-slider").slider("destroy");
                $("#volume-slider").slider("destroy");
            }

            
            var minPrice = parseInt(selected.attr('data-min-price-range'));
            var maxPrice = parseInt(selected.attr('data-max-price-range'));
            var minRecoPrice = parseInt(selected.attr('data-min-price-reco-range'));
            var maxRecoPrice = parseInt(selected.attr('data-max-price-reco-range'));
            var recoPriceText = selected.attr('data-reco-text');
            var marginLabel = selected.attr('data-label');

            $('.slider-range-label.price-range .min').html(minPrice);
            $('.slider-range-label.price-range .max').html(maxPrice);
            $(".price-reco-text").text(`${recoPriceText}`);

            $('.margin-title').html(marginLabel);

             // Price range slider ($7 - $9)
            $("#price-slider").slider({
                range: "min",
                min: minPrice,
                max: maxPrice,
                step: 1,
                // values: [minRecoPrice, maxRecoPrice],
                values: [minRecoPrice],
                slide: function(event, ui) {
                    // Update text below handles while sliding
                    $("#price-slider .ui-slider-handle").eq(0).find(".handle-value").text('$'+ui.values[0]);
                    // $("#price-slider .ui-slider-handle").eq(1).find(".handle-value").text('$'+ui.values[1]);
                },
                create: function() {
                    // Add labels under handles initially
                    $("#price-slider .ui-slider-handle").each(function(i) {
                        var value = $("#price-slider").slider("values", i);
                        $(this).append('<div class="handle-value">$' + value + '</div>');
                    });
                }
            });
            
            var minVolume = parseInt(selected.attr('data-min-volume-range'));
            var maxVolume = parseInt(selected.attr('data-max-volume-range'));
            var minRecoVolume = parseInt(selected.attr('data-min-volume-reco-range'));
            var maxRecoVolume = parseInt(selected.attr('data-max-volume-reco-range'));
            var recoVolumeText = selected.attr('data-reco-volume-text');
            
            $('.slider-range-label.volume-range .min').html(minVolume);
            $('.slider-range-label.volume-range .max').html(maxVolume);
            $(".volume-reco-text").text(`${recoVolumeText}`);

            $("#volume-slider").slider({
                range: "min",
                min: minVolume,
                max: maxVolume,
                step: 10,
                values: [minRecoVolume],
                // values: [minRecoVolume, maxRecoVolume],
                slide: function(event, ui) {
                    // Update text below handles while sliding
                    $("#volume-slider .ui-slider-handle").eq(0).find(".handle-value").text(''+ui.values[0]);
                    // $("#volume-slider .ui-slider-handle").eq(1).find(".handle-value").text(''+ui.values[1]);
                },
                create: function() {
                    // Add labels under handles initially
                    $("#volume-slider .ui-slider-handle").each(function(i) {
                        var value = $("#volume-slider").slider("values", i);
                        $(this).append('<div class="handle-value">' + value + '</div>');
                    });
                }
            });
            $('.margin-2-container .btn-continue').prop('disabled',false);

        
            

        }

        if (nextStep == 3){
            
            var resultAction = selected.attr('data-action');
            var resultLabelProfit = selected.attr('data-result-label-profit');
            var purchasePrice = parseFloat(selected.attr('data-purchase-price'));

            var selectedMinPrice = $("#price-slider .ui-slider-handle").eq(0).find(".handle-value").html().replace('$','').trim();
            var selectedPriceAvg = parseInt(selectedMinPrice);
            // var selectedMaxPrice = $("#price-slider .ui-slider-handle").eq(1).find(".handle-value").html().replace('$','').trim();
            // var selectedPriceAvg = (parseInt(selectedMinPrice) + parseInt(selectedMaxPrice)) / 2;


            var selectedMinVolume = $("#volume-slider .ui-slider-handle").eq(0).find(".handle-value").html().replace('$','').trim();
            // var selectedMaxVolume = $("#volume-slider .ui-slider-handle").eq(1).find(".handle-value").html().replace('$','').trim();
            // var selectedVolumeAvg = (parseInt(selectedMinVolume) + parseInt(selectedMaxVolume)) / 2;
            var selectedVolumeAvg = parseInt(selectedMinVolume);


            var selectedTotalCost = purchasePrice * selectedVolumeAvg;

            switch (resultAction) {
                case 'single-sachet':

                    var profitPerSachet = selectedPriceAvg - purchasePrice;
                    var monthlyNetRev = profitPerSachet * selectedVolumeAvg;

                    $('.result-profit .text').html(resultLabelProfit);
                    $('.result-cost .value').html(purchasePrice.toFixed(2));
                    $('.result-profit .value').html(profitPerSachet.toFixed(2));
                    
                    $('.result-montly-net-rev .value').html(monthlyNetRev.toFixed(2));
                break;

                break;
            
                default:
                    var profitPerSachet = selectedPriceAvg - purchasePrice;
                    var monthlyNetRev = profitPerSachet * selectedVolumeAvg;

                    $('.result-profit .text').html(resultLabelProfit);
                    $('.result-cost .value').html(purchasePrice.toFixed(2));
                    $('.result-profit .value').html(profitPerSachet.toFixed(2));
                    
                    $('.result-montly-net-rev .value').html(monthlyNetRev.toFixed(2));

                    break;
            }

            
            

            //result-montly-net-rev

            
        }

        $(`.margin-${step}-container`).removeClass('active');
        $(`.margin-${nextStep}-container`).addClass('active');
        
        

    });
    
    $(document).on('click','.margin-calculator-container .btn-get-started',function(){

        $.magnificPopup.close();
        $('html, body').animate({
            scrollTop: $('.portal-welcome-kit-container').offset().top
        }, 600); // 600ms for smooth scroll

    });


    // const variantA = 52215554605240; //Vanilla Ice Cream
    // const variantB = 52215554769080;

    const variantA = 52215554605240; //Vanilla Ice Cream
    const variantB = 52215554769080;
    var quantityA = 12;
    var quantityB = 12;

    $('#welcome-kit-checkout').on('click', function() {
      const $btn = $(this);

      var originalHTML = $btn.html();
      
        const qty = parseInt($btn.attr('data-quantity'));

        // alert(qty);

        quantityA*=qty;
        quantityB*=qty;

     const _bundle_group_id = Math.floor(Date.now() / 1000);
      let data = {};

      data.items = [];

      data.items.push(
        { 
            id : variantA, 
            quantity: quantityA,
            properties: {
                "_BUNDLE": 'Wholesale',
                "Bundle" : 'Retailers Essentials Bundle',
                "Wholesale Group ID" : _bundle_group_id,
                "Wholesale Group" : '1 out 2',
                "_bundle_group_id" : _bundle_group_id,
                "_bundle_group_product" : true,
                "_bundle_group_product_row" : 1,
                "_bundle_group_payment_type" : 'one-time',
                "_bundle_group_oneitem_price" : $('.welcome-kit-total-amount').html(),
            }

        }
      );
      data.items.push(
        { 
            id : variantB, 
            quantity: quantityB,
            properties: {
                "_BUNDLE": 'Wholesale',
                "Bundle" : 'Retailers Essentials Bundle',
                "Wholesale Group ID" : _bundle_group_id,
                "Wholesale Group" : '2 out 2',
                "_bundle_group_id" : _bundle_group_id,
                "_bundle_group_product" : true,
                "_bundle_group_product_row" : 2
            }
        }
      );

      // Bottle
    //   if (!bottleOOS) {
    //         data.items.push(
    //             { 
    //                 id : 53301741289656, 
    //                 quantity: 5,
    //                 properties: {
    //                     "_BUNDLE": 'Wholesale',
    //                     "Bundle" : 'Retailers Essentials Bundle',
    //                     "Wholesale Group ID" : _bundle_group_id,
    //                     "_bundle_group_id" : _bundle_group_id,
    //                     "_bundle_group_product" : true,
    //                     "_bundle_group_product_row" : 3
    //                 }
    //             }
    //     );
    //     }
    //   if (!frotherOOS) {
    //     data.items.push(
    //         { 
    //             id : 51843757670584, 
    //             quantity: 5,
    //             properties: {
    //                 "_BUNDLE": 'Wholesale',
    //                 "Bundle" : 'Retailers Essentials Bundle',
    //                 "Wholesale Group ID" : _bundle_group_id,
    //                 "_bundle_group_id" : _bundle_group_id,
    //                 "_bundle_group_product" : true,
    //                 "_bundle_group_product_row" : 4
    //             }
    //         }
    //     );
    //   }


      // Disable button + show loading text
      $btn.prop('disabled', true).text('Please wait...');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json'
        })
        .done(function() {
    
            
            // $.ajax({
            //     url: '/discount/' + encodeURIComponent(cartDiscountCode),
            //     method: 'GET',
            //     xhrFields: { withCredentials: true },
            // })
            // .done(function (res, status, xhr) {
                $btn.prop('disabled', false).html(originalHTML);
                // Once discount cookie is set, update and open the cart drawer
                if (typeof FonCartDrawer !== 'undefined') {
                    FonCartDrawer.updateCartDrawer();
                    FonCartDrawer.openCartDrawer();
                }
            // })
            // .fail(function (xhr, status, error) {
            //     console.warn('Failed to apply discount:', xhr.status, error);
            // });

        })
        .fail(function() {
          alert('Failed to add items to the cart.');
          $btn.prop('disabled', false).text('Checkout'); // reset on error
        });


      

    });


    
    $(document).on('click','.quiz-quantity-selector-shop-all button',function(){

        var parentOuter = $(this).parents('.portal-products-box');
        var parent = $(this).parents('.quiz-quantity-selector');
        var quantity = parseInt(parent.attr('data-quantity'));

        var action = $(this).attr('data-action');
        
     
        switch (action){
            case 'minus':
                quantity--;
            break;
            case 'plus':
                quantity++;
            break;
        }
        parent.attr('data-quantity',quantity);

        let quantitityLabel = quantity;


        if (!$(this).parents('.portal-products-box').hasClass('portal-products-box-accessory')){

            let sachetsMultiplier = 120;
            let pouchMultiplier = 6;
            
            if (quantity > 1){

                if (parent.find('.quantity-value').hasClass('quantity-value-sachets')){
                    quantitityLabel = quantity + ' Cartons <span class="d-block d-md-inline">(' + (quantity * sachetsMultiplier) + ' Sachets)</span>';
                }else{
                    quantitityLabel = quantity + ' Cartons <span class="d-block d-md-inline">(' + (quantity * pouchMultiplier) + ' Pouches)</span>';
                }

            }else{
                if (parent.find('.quantity-value').hasClass('quantity-value-sachets')){
                    quantitityLabel = quantity + ' Carton <span class="d-block d-md-inline">(' + (quantity * sachetsMultiplier) + ' Sachets)</span>';
                }else{
                    quantitityLabel = quantity + ' Carton <span class="d-block d-md-inline">(' + (quantity * pouchMultiplier) + ' Pouches)</span>';
                }
            }
        }

        parent.find('.quantity-value').html(quantitityLabel);


        parentOuter.find('.product-quantity-label span').html(quantity);

        var variantPrice = parseFloat(parentOuter.find('.btn-quick-add').attr('data-variant-price'));
        var variantSubTotal = variantPrice * quantity;

        parentOuter.find('.btn-quick-add').attr('data-quantity',quantity);
        parentOuter.find('.btn-quick-add .with-currency-code').html(variantSubTotal);
        

        if (quantity == 1){
            parent.find('button.btn-quiz-qty[data-action=minus]').prop('disabled',true);
        }else{
            parent.find('button.btn-quiz-qty[data-action=minus]').prop('disabled',false);
        }

    });


    $(document).on('click','.quiz-quantity-selector-welcomekit button',function(){

        var parentOuter = $(this).parents('.welcome-kit-button');
        var parent = $(this).parents('.quiz-quantity-selector');
        var quantity = parseInt(parent.attr('data-quantity'));
        var cost = parseFloat(parent.attr('data-cost'));

        var action = $(this).attr('data-action');

        var totalCost = quantity * cost;

        
     
        switch (action){
            case 'minus':
                quantity--;
            break;
            case 'plus':
                quantity++;
            break;
        }
        parent.attr('data-quantity',quantity);

        let quantitityLabel = quantity;
        let sachetsMultiplier = 120;
        let pouchMultiplier = 6;
        
        if (quantity > 1){

            quantitityLabel = quantity + ' Bundles';

        }else{
            quantitityLabel = quantity + ' Bundle';
        }

        parent.find('.quantity-value').html(quantitityLabel);


        parentOuter.find('.product-quantity-label span').html(quantity);

      
        var variantSubTotal = cost * quantity;

        parentOuter.find('.action button').attr('data-quantity',quantity);
        parentOuter.find('.action button .with-currency-code').html(variantSubTotal);
        

        if (quantity == 1){
            parent.find('button.btn-quiz-qty[data-action=minus]').prop('disabled',true);
        }else{
            parent.find('button.btn-quiz-qty[data-action=minus]').prop('disabled',false);
        }

    });




    $(document).on('click', '.btn-quick-add', function (e) {
        e.preventDefault();

        var $button = $(this);
        var variantId = $button.data('variant-id');
        var originalText = $button.html();

         // Step 1: Show "Adding to cart..."
            $button.prop('disabled', true);
            $button.find('.text').html('Please wait...');

        var price = $(this).find('.with-currency-code').html().trim();
        const _bundle_group_id = Math.floor(Date.now() / 1000);

        description = '';

        if (!$(this).parents('.portal-products-box').hasClass('portal-products-box-accessory')){


            var qty = parseInt($button.data('quantity')) * 6; // Set

            description = $(this).parents('.product-item').find('.variant-description').text();
            if (qty > 6){
                description = $(this).parents('.product-item').find('.quantity-value').text();
            }
        }else{
            description = $(this).parents('.product-item').find('.variant-description').text();
            var qty = parseInt($button.data('quantity')); // Set
        }


        var items = [{
            id: variantId,
            quantity: qty,
            properties: {
                "_BUNDLE": 'Wholesale Product',
                "Wholesale Group ID" : variantId,
                "_bundle_group_id" : variantId,
                "_bundle_group_product" : true,
                "_bundle_group_product_row" : 1,
                "_bundle_group_payment_type" : 'one-time',
                "_bundle_group_oneitem_price" : price,
                // "_bundle_group_description" : description,
            }
        }];

        // Step 2: Send AJAX request to add to cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                console.log('Items added:', data);

                // $.ajax({
                //     url: '/discount/' + encodeURIComponent(cartDiscountCode),
                //     method: 'GET',
                //     xhrFields: { withCredentials: true },
                // })
                // .done(function (res, status, xhr) {
                    // Once discount cookie is set, update and open the cart drawer
                    if (typeof FonCartDrawer !== 'undefined') {
                        FonCartDrawer.updateCartDrawer();
                        FonCartDrawer.openCartDrawer();
                    }
                    $button.html(originalText).prop('disabled',false);
                // })
                // .fail(function (xhr, status, error) {
                //     console.warn('Failed to apply discount:', xhr.status, error);
                // });

            },
            error: function (xhr, status, error) {
                console.error('Error adding to cart:', error);
                $button.text('Quick Add').prop('disabled', false);
            }
        });
    });



    // $(document).on('click', '.btn-quick-add-promo-kit', function (e) {
    //     e.preventDefault();

    //     var $button = $(this);
    //     var variantId = $button.data('variant-id');
    //     var originalText = $button.html();

    //      // Step 1: Show "Adding to cart..."
    //         $button.prop('disabled', true);
    //         $button.find('.text').html('Please wait...');

    //     var price = $(this).find('.with-currency-code').html().trim();
    //     const _bundle_group_id = Math.floor(Date.now() / 1000);

    //     if (!$(this).parents('.portal-products-box').hasClass('portal-products-box-accessory')){


    //         var qty = parseInt($button.data('quantity')) * 6; // Set

    //         var description = $(this).parents('.product-item').find('.variant-description').text();
    //         if (qty > 6){
    //             description = $(this).parents('.product-item').find('.quantity-value').text();
    //         }
    //     }else{

    //         var qty = parseInt($button.data('quantity')); // Set
    //         var description = ''
    //     }


    //     var items = [{
    //         id: variantId,
    //         quantity: qty,
    //         properties: {
    //             "_BUNDLE": 'Wholesale Product',
    //             "Wholesale Group ID" : _bundle_group_id,
    //             "_bundle_group_id" : _bundle_group_id,
    //             "_bundle_group_product" : true,
    //             "_bundle_group_product_row" : 1,
    //             "_bundle_group_payment_type" : 'one-time',
    //             "_bundle_group_oneitem_price" : price,
    //             "_bundle_group_description" : description,
    //         }
    //     }];

    //     // Step 2: Send AJAX request to add to cart
    //     $.ajax({
    //         type: 'POST',
    //         url: '/cart/add.js',
    //         data: JSON.stringify({ items: items }),
    //         dataType: 'json',
    //         contentType: 'application/json; charset=utf-8',
    //         success: function (data) {
    //             console.log('Items added:', data);

    //             // $.ajax({
    //             //     url: '/discount/' + encodeURIComponent(cartDiscountCode),
    //             //     method: 'GET',
    //             //     xhrFields: { withCredentials: true },
    //             // })
    //             // .done(function (res, status, xhr) {
    //                 // Once discount cookie is set, update and open the cart drawer
    //                 if (typeof FonCartDrawer !== 'undefined') {
    //                     FonCartDrawer.updateCartDrawer();
    //                     FonCartDrawer.openCartDrawer();
    //                 }
    //                 $button.html(originalText).prop('disabled',false);
    //             // })
    //             // .fail(function (xhr, status, error) {
    //             //     console.warn('Failed to apply discount:', xhr.status, error);
    //             // });

    //         },
    //         error: function (xhr, status, error) {
    //             console.error('Error adding to cart:', error);
    //             $button.text('Quick Add').prop('disabled', false);
    //         }
    //     });
    // });



    function updateFraction(swiper) {
        var current = swiper.realIndex + 1;
        var total = swiper.slides.length;
        document.querySelector('.swiper-pagination-fraction').innerHTML = '<strong>'+current+'</strong>' + '/' + total;
    }

    // const swiperCompetitionSlider = new Swiper('.swiper-portal-partnership', {
    //     slidesPerView: 1, // show partial next/prev
    //     spaceBetween: 0,
    //     centeredSlides: true,
    //     initialSlide: 0, // ✅ Force it to start at the first slide
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true,
    //     },
    //     autoplay: {
    //     delay: 3000, // ⏱️ 3 seconds between slides
    //     disableOnInteraction: false, // 🚫 keeps autoplay running after user interaction
    // },
    //     breakpoints: {
    //     567: {
    //         // spaceBetween: 46,
    //         spaceBetween: 30,
    //         slidesPerView: 6.4,
    //         // slidesPerView: 3,
    //         // centeredSlides: true,
    //     },
    //     }
    // });

    // const swiperParnershipSlider = new Swiper('.swiper-portal-partnership', {
    //     slidesPerView: 2.3,
    //     spaceBetween: 15,
    //     // initialSlide: 0, // ✅ Force it to start at the first slide
    //     loop: true, // ♾️ Enable infinite looping
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true,
    //     },
    //     autoplay: {
    //         delay: 0, // ⏱️ 3 seconds between slides
    //         disableOnInteraction: false, // 🚫 keeps autoplay running after user interaction
    //     },
    //     speed: 10000,
    //     breakpoints: {
    //         567: {
    //             spaceBetween: 30,
    //             slidesPerView: 5,
    //         },
    //     },
    // });

   const swiperParnershipSlider = new Swiper('.swiper-portal-partnership', {
    slidesPerView: 2.3,
    spaceBetween: 15,
    loop: true, // ♾️ Infinite loop
    freeMode: true, // ✅ enables continuous flow
    freeModeMomentum: false,
    allowTouchMove: false, // 🚫 optional: prevent user drag if you want pure continuous scroll
    grabCursor: false,
    speed: 8000, // 🎬 duration of transition
    autoplay: {
        delay: 0, // makes it continuous
        disableOnInteraction: false,
        pauseOnMouseEnter: false, // 🚫 don't pause on hover
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        567: {
            spaceBetween: 30,
            slidesPerView: 7,
        },
    },
});


    const swiperPortalTiers = new Swiper('.swiper-portal-tiers', {
        slidesPerView: 1, // show partial next/prev
        spaceBetween: 0,
        centeredSlides: true,
        initialSlide: 0, // ✅ Force it to start at the first slide,
        pagination: {
            el: '.swiper-pagination-bullets',
            clickable: true
        },
        on: {
          init: function () {
            updateFraction(this);
          },
          slideChange: function () {
            updateFraction(this);
          }
        },
        breakpoints: {
            567: {
                initialSlide: 0, // ✅ Force it to start at the first slide
                spaceBetween: 46,
                slidesPerView: 3,
                centeredSlides: false,
            },
        }
    });
   
    $('.link-cross-reference').each(function(){
        var sku = $(this).data('variant-sku');
        var variantLink = $('.change-bundle-variant-id[data-sku="'+sku+'"]').data('variant-link');
        $(this).attr('href',variantLink);

    });


    $('.reorder-btn').on('click', function() {

        // $('body').removeClass('body-account-retailer-drawer');

        const $button = $(this);
        const originalText = $button.text();
        const items = JSON.parse($button.attr('data-items'));

        // Disable button to prevent double clicks
        $button.text('Reordering...').prop('disabled', true);

        // Step 1: Clear the current cart
        $.post('/cart/clear.js')
            .done(function() {
            console.log('Cart cleared');

            // Step 2: Add all order items at once
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({ items: items }),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: function(data) {
                console.log('Items added:', data);

                // Step 3: Redirect to checkout after successful add
                window.location.href = '/checkout';
                },
                error: function(xhr, status, error) {
                console.error('Error adding to cart:', error);
                alert('Some items could not be added. Please try again.');
                $button.text(originalText).prop('disabled', false);
                }
            });
            })
            .fail(function(xhr, status, error) {
            console.error('Error clearing cart:', error);
            alert('Unable to clear cart. Please try again.');
            $button.text(originalText).prop('disabled', false);
            });
        });



    $(document).on('click', '.btn-track-see-tracking', function(e) {
        e.preventDefault(); // prevent default link action

        const orderNumber = $(this).data('order-number');
        const customerName = $(this).data('customer-name');
        const customerEmail = $(this).data('custumer-email'); // note spelling matches your attribute

        if (!orderNumber || !customerEmail) {
            console.error('Missing required data attributes');
            return;
        }

        // Build GET request parameters
        const params = {
            order_number: orderNumber,
            customer_name: customerName,
            customer_email: customerEmail
        };

        $.get(
            'https://app.usefon.com/wp-json/fon/v1/retailers-request-tax-invoice',
            params,
            function(response) {
            console.log('Response:', response);
                $.magnificPopup.open({
                    items: {
                    src:
                        '<div class="white-popup mfp-fade overflow-visible" style="padding:30px;max-width:400px;margin:0 auto;text-align:center;">' +
                        '<p>You will receive your Tax Invoice within <strong>1–2 business days</strong>.</p>' +
                        '</div>',
                    type: 'inline'
                    },
                    closeBtnInside: true,
                    closeMarkup: `
                    <button title="%title%" type="button" class="mfp-close mfp-close-special">
                        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                        </svg>
                    </button>
                    `,
                });
            }
        ).fail(function(err) {
            console.error('❌ Request failed:', err);
            alert('❌ Failed to send tax invoice request. Please try again.');
        });
    });


    

    new Swiper(".swiper-retailers-partner", {
        slidesPerView: 1.4,
        spaceBetween: 20,
        loop: true,
        speed: 4000, // smooth speed
        autoplay: {
        delay: 0, // continuous
        disableOnInteraction: false,
        },
        freeMode: {
        enabled: true,
        sticky: false,
        momentum: false,
        },
        breakpoints: {
        768: {
            slidesPerView: 6,
            spaceBetween: 40,
        },
        },
    });


    $(document).on('click','.btn-dc-generic.btn-quick-add-custom',function(){
        $.magnificPopup.open({
            callbacks: {
          open: function() {
              console.log('Popup body-inline-bottom');
              $('body').addClass('body-popup-slide');
          },
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('body-popup-slide');
          }
    },
    mainClass: 'mfp-animate-bottom',
            items: {
            src: $('#custom-build-popup').html(),
            type: 'inline'
            },
            closeBtnInside: true,
            closeMarkup: `
            <button title="%title%" type="button" class="mfp-close mfp-close-special">
                <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                </svg>
            </button>
            `,
        });
    });


    // $('.btn-dc-generic.btn-quick-add-custom').trigger('click');
    
    
    $('.btn-custom-add-to-cart-custom').prop('disabled',true);
    $(document).on('click','.quiz-quantity-selector-custom button',function(){

        var parentOuter  = $(this).parents('.custom-build-container');
        var parent  = $(this).parents('.portal-products-box');
        var totalQty = parseInt($('.custom-build-container').find('.dynamic-selected').html().trim());
        
        
        var qtyBtn = $(this);
        var qytBtnAction = qtyBtn.attr('data-action');

        var quantityValueEl = parent.find('.quantity-value');
        var quantityValue = parseInt(quantityValueEl.html());

        if (totalQty <= 6){

            

            switch (qytBtnAction){
                case 'minus':
                    if (quantityValue > 0){
                        quantityValue--;
                    }
                break;
                case 'plus':
                    quantityValue++;
                break;
            }

            quantityValueEl.html(quantityValue);
            
        }
      

        // Compute Selection Total
        totalQty = 0;
        parentOuter.find('.quantity-value').each(function(){
            totalQty+=parseInt($(this).html());
            $('.custom-build-container').find('.dynamic-selected').html(totalQty);
        });

          

        // Disable all plus button
        if (totalQty > 5 ){
            parentOuter.find('.btn-quiz-qty[data-action="plus"]').prop('disabled',true);
        }else{
            parentOuter.find('.btn-quiz-qty[data-action="plus"]').prop('disabled',false);
        }

        // OVerall
        var overallTotal = 0;
        $('.custom-build-products-container').find('.quantity-value').each(function(){
            overallTotal+=parseInt($(this).html());
        });

        if (overallTotal == 6){
            $('.btn-custom-add-to-cart-custom').prop('disabled',false);
        }else{
            $('.btn-custom-add-to-cart-custom').prop('disabled',true);
        }

    });



    $(document).on('click','.btn-custom-add-to-cart-custom',function(){

        var parentOuter = $('.custom-build-products-container');
      

        const $btn = $(this);
        const _bundle_group_id = Math.floor(Date.now() / 1000);
        let data = {};

        data.items = [];

        var totalProductsType = 0;
        var totalUniqueCount = 1;
        var description = '';
        var inclusions = [];

        parentOuter.find('.quantity-value').each(function(){
            var quantity = parseInt($(this).html());
            var variantID = $(this).data('variant-id');

            if (quantity > 0){
                totalProductsType++;
                var prodouctTitle = $(this).parents('.product-box').find('.variant-title .first').html().trim();
                var prodouctFlavour = $(this).parents('.product-box').find('.variant-title .second').html().trim();
                inclusions.push(quantity + 'x ' + prodouctTitle + ' - ' + prodouctFlavour);
            }
        });


        // Generate description from inclusions
        var description = '';
        var allButLast = inclusions.slice(0, -1).join(', ');
        var last = inclusions[inclusions.length - 1];
        description = `Contents: ${allButLast}, and ${last}.`;


        parentOuter.find('.quantity-value').each(function(){
            
            var quantity = parseInt($(this).html());
            var variantID = $(this).data('variant-id');
            if (quantity > 0){
                
                
                data.items.push(
                    { 
                        id : variantID, 
                        quantity: quantity,
                        properties: {
                            "_BUNDLE": 'Wholesale Mix & Match',
                            "Bundle" : 'Wholesale Mix & Match',
                            "Wholesale Mix & Match ID" : _bundle_group_id,
                            "Wholesale Mix & Match" : totalUniqueCount + ' out ' + totalProductsType,
                            "_bundle_group_id" : _bundle_group_id,
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : totalUniqueCount,
                            "_bundle_group_payment_type" : 'one-time',
                            "_bundle_group_oneitem_price" : $('.welcome-kit-total-amount').html(),
                            "_bundle_group_description" : description,
                        }

                    }
                );

                totalUniqueCount++;

                


            }

      
        });
        

        console.log('data',data);

        // Disable button + show loading text
        $btn.prop('disabled', true).text('Preparing your bundle...');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json'
        })
        .done(function() {
            
            $.magnificPopup.close();
            
            $btn.prop('disabled', false).text('Add To Cart');
            // Once discount cookie is set, update and open the cart drawer
            if (typeof FonCartDrawer !== 'undefined') {
                FonCartDrawer.updateCartDrawer();
                FonCartDrawer.openCartDrawer();
            }

        })
        .fail(function() {
          alert('Failed to add items to the cart.');
          $btn.prop('disabled', false).text('Checkout'); // reset on error
        });





    });


});